import { UnitTypeLongPlural } from 'dayjs';
import { Duration } from 'dayjs/plugin/duration';
import { TFunction } from 'i18next';

export interface IGetDurationStrOptions {
	exclude?: UnitTypeLongPlural[];
	withAround?: boolean;
}

export function getDurationStr(
	t: TFunction,
	duration: Duration,
	excludeOrOptions?: UnitTypeLongPlural[] | IGetDurationStrOptions
) {
	const options: IGetDurationStrOptions = Array.isArray(excludeOrOptions)
		? { exclude: excludeOrOptions }
		: excludeOrOptions ?? {};

	const { exclude = [], withAround = false } = options;

	const durationSeconds = duration.seconds();
	const durationMinutes = duration.minutes();
	const durationHours = duration.hours();
	const durationDays = duration.days();

	const hasHours =
		(durationHours > 0 && !exclude.includes('hours')) ||
		(durationDays > 0 && !exclude.includes('days'));

	const parts = [
		durationDays > 0 &&
			!exclude.includes('days') &&
			durationDays + t('common:time.short.days'),
		durationHours > 0 &&
			!exclude.includes('hours') &&
			durationHours + t('common:time.short.hours'),
		durationMinutes > 0 &&
			!exclude.includes('minutes') &&
			durationMinutes + (hasHours ? '' : ' ') + t('common:time.short.minutes'),
		durationSeconds > 0 &&
			!exclude.includes('seconds') &&
			durationSeconds + t('common:time.short.seconds'),
	]
		.filter(Boolean)
		.join(' ');

	if (withAround && parts) {
		return `${t('common:text.around')} ${parts}`;
	}

	return parts;
}
